import { useContext } from 'react';
import { XingFrameContext } from '@xingternal/xing-frame-provider';

export const useXingFrame = () => useContext(XingFrameContext);

export default useXingFrame;

export enum FEATURE_SWITCHES {}
